import { render, staticRenderFns } from "./ReceiveSubmit.vue?vue&type=template&id=c2999caa&scoped=true&"
import script from "./ReceiveSubmit.vue?vue&type=script&lang=js&"
export * from "./ReceiveSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveSubmit.vue?vue&type=style&index=0&id=c2999caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2999caa",
  null
  
)

export default component.exports